import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function ProductRSE({
  htmlContent,
  handleContentHeight,
}: {
  htmlContent?: string;
  handleContentHeight?: () => void;
}): JSX.Element {
  const { t } = useTranslation(['productPage']);

  useEffect(() => {
    if (typeof handleContentHeight === 'function') handleContentHeight();
  }, [htmlContent]);

  if (!htmlContent) {
    return <>{t('LABEL_TAB_RSE_NO_DATA')}</>;
  }

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
}

export default ProductRSE;
